import { computed, defineComponent, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { setHead } from '@/composables/useHead';
export default defineComponent({
    name: 'Privacy',
    setup() {
        const { t, tm } = useI18n();
        const sections = computed(() => tm('privacy.sections'));
        onMounted(() => {
            setHead({
                title: t('seo.privacy.title'),
                description: t('seo.privacy.description'),
                basePath: '/privacy',
                ogImage: 'https://www.travellingdominika.com/og-image.jpg',
            });
        });
        return { sections };
    },
});
